import { HeaderWithContext as Header } from './Header';

export { HeaderWithCustomContent } from './Header';

export default Header;